/* eslint-disable brace-style */
/* eslint-disable no-restricted-syntax */
import {
  LedgerTypeData,
  LedgerTypeId,
  SearchLedgerTypesProviderInterface,
} from "@totalenergiescode/mobility-business-rev-form-data/components";
import { GraphQLClient } from "graphql-request";

import { getGraphqlClient } from "@/api/graphql/client";
import {
  CountLedgersByStatusQuery,
  GetOrderableWalletLedgerTypesQuery,
  LedgersMsSearchLedgersQuery,
  SearchLedgersListQuery,
  SearchLedgersStatus,
} from "@/api/graphql/ledgers/search/queries";
import {
  GetCountLedgersByStatusArgs,
  GetSearchLedgersArgs,
  GetSearchLedgersProductArgs,
} from "@/api/graphql/ledgers/search/types";
import { PAGINATION } from "@/constants/constants";

export const getSearchLedgersStatus = () => {
  const graphqlClient = getGraphqlClient();

  return graphqlClient.request(SearchLedgersStatus, {
    request: {
      filters: {},
      paging: {
        page: PAGINATION.DEFAULT_FIRST_PAGE,
        size: PAGINATION.DEFAULT_PER_PAGE,
      },
      sorts: [],
    },
  });
};

export const getSearchLedgers = ({
  filters,
  paging,
  sorts,
}: GetSearchLedgersArgs) => {
  const graphqlClient = getGraphqlClient();

  const page = paging?.page || 1;

  const ids = filters?.ids || [];
  const statusIds = filters?.statusIds;
  const walletId = filters?.walletId || "";
  const size = paging?.size || PAGINATION.DEFAULT_PER_PAGE;
  const pcomType = filters?.pcomType || undefined;
  const query = filters?.query || undefined;

  return graphqlClient.request(SearchLedgersListQuery, {
    request: {
      filters: {
        ids,
        statusIds,
        walletId,
        pcomType,
        query,
      },
      paging: {
        page,
        size,
      },
      sorts,
    },
  });
};

export const getCountLedgersByStatus = ({
  metrics,
  pcomType,
}: GetCountLedgersByStatusArgs) => {
  const graphqlClient = getGraphqlClient();

  return graphqlClient.request(CountLedgersByStatusQuery, {
    request: {
      statusCodes: metrics?.statusCodes || [],
      pcomType,
    },
  });
};

export const getSearchLedgersProduct = ({
  id,
}: GetSearchLedgersProductArgs) => {
  const graphqlClient = getGraphqlClient();

  return graphqlClient.request(LedgersMsSearchLedgersQuery, {
    request: {
      filters: {
        ids: [id],
      },
    },
  });
};

export const getSearchLedgerByShortCode = (shortCode: string) => {
  const graphqlClient = getGraphqlClient();

  return graphqlClient.request(SearchLedgersListQuery, {
    request: {
      filters: {
        query: shortCode,
      },
      paging: {
        page: PAGINATION.DEFAULT_FIRST_PAGE,
        size: 1, // We only need one result
      },
      sorts: [],
    },
  });
};

export const GetOrderableWalletLedgerTypes = (walletId: string) => {
  const graphqlClient = getGraphqlClient();

  return graphqlClient.request(GetOrderableWalletLedgerTypesQuery, {
    request: {
      walletId,
    },
  });
};

export class SearchLedgerTypesProvider
  implements SearchLedgerTypesProviderInterface
{
  constructor(private graphqlClient: GraphQLClient) {}

  async search(walletId: string): Promise<Map<LedgerTypeId, LedgerTypeData>> {
    const result = await this.graphqlClient.request(
      GetOrderableWalletLedgerTypesQuery,
      {
        request: {
          walletId,
        },
      },
    );

    const ledgerTypes = result.LedgersMsGetOrderableWalletLedgerTypes?.data;

    const ledgerTypesMap = new Map<LedgerTypeId, LedgerTypeData>();

    if (!ledgerTypes) {
      return ledgerTypesMap;
    }

    for (const ledgerType of ledgerTypes) {
      ledgerTypesMap.set(ledgerType.id, {
        ledgerTypeId: ledgerType.id,
        group: ledgerType.groupId,
        label: ledgerType.codeHint
          ? `${ledgerType.code} — ${ledgerType.codeHint}`
          : ledgerType.code,
        // keep raw values for consumers that need them
        code: ledgerType.code,
        codeHint: ledgerType.codeHint,
      } as LedgerTypeData & { code?: string; codeHint?: string });
    }

    return ledgerTypesMap;
  }
}
